import { SmsGatewaysTable } from '@/components/features/sms-gateways/SmsGatewaysTable'

export const SMSGateways = () => {
  return <SmsGatewaysTable />
}
